(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const routes = (window.FILTRD && window.FILTRD.routes) || { cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Announcement bar rotator */
  $$('[data-rotator]').forEach((track) => {
    const items = $$('.announce__item', track);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, (parseInt(track.dataset.rotator, 10) || 5) * 1000);
  });

  /* Header shadow + mobile nav */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const nav = $('#MobileNav');
    const openBtn = $('[data-nav-open]');
    const setNav = (open) => {
      nav.hidden = !open;
      openBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    openBtn && openBtn.addEventListener('click', () => setNav(true));
    nav && nav.addEventListener('click', (e) => {
      if (e.target === nav || e.target.closest('[data-nav-close]') || e.target.closest('a')) setNav(false);
    });
  }

  /* Fade sliders (hero + product gallery) */
  $$('[data-slider]').forEach((slider) => {
    const slides = $$('[data-slide]', slider);
    const dots = $$('[data-slider-dot]', slider);
    if (slides.length < 2) {
      slider.classList.toggle('is-dark', !!(slides[0] && slides[0].hasAttribute('data-dark')));
      return;
    }
    let index = 0;
    let timer = null;
    const go = (n) => {
      index = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === index));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === index));
      slider.classList.toggle('is-dark', slides[index].hasAttribute('data-dark'));
    };
    const autoplay = parseInt(slider.dataset.autoplay || '0', 10);
    const start = () => { if (autoplay > 0 && !reduceMotion) { stop(); timer = setInterval(() => go(index + 1), autoplay * 1000); } };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const prev = $('[data-slider-prev]', slider);
    const next = $('[data-slider-next]', slider);
    prev && prev.addEventListener('click', () => { go(index - 1); start(); });
    next && next.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.sliderDot, 10)); start(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    let x0 = null;
    slider.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    go(0);
    start();
  });

  /* Horizontal rails (reviews) */
  $$('[data-rail-wrap]').forEach((wrap) => {
    const rail = $('[data-rail]', wrap);
    const step = () => Math.max(260, rail.clientWidth * 0.8);
    const prev = $('[data-rail-prev]', wrap); const next = $('[data-rail-next]', wrap);
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* Water compare slider */
  $$('[data-compare]').forEach((cmp) => {
    const range = $('[data-compare-range]', cmp);
    const set = (v) => { const n = Math.max(0, Math.min(100, v)); cmp.style.setProperty('--pos', n + '%'); range.value = n; };
    range.addEventListener('input', () => set(parseFloat(range.value)));
    // Drag anywhere on the image with mouse or finger (touch-action: pan-y keeps vertical page scrolling)
    let dragging = false;
    const fromEvent = (e) => { const r = cmp.getBoundingClientRect(); set(((e.clientX - r.left) / r.width) * 100); };
    cmp.addEventListener('pointerdown', (e) => {
      dragging = true; cmp.classList.add('is-dragging'); cmp.classList.remove('is-hinting');
      try { cmp.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      fromEvent(e);
    });
    cmp.addEventListener('pointermove', (e) => { if (dragging) fromEvent(e); });
    const stop = () => { dragging = false; cmp.classList.remove('is-dragging'); };
    cmp.addEventListener('pointerup', stop);
    cmp.addEventListener('pointercancel', stop);
    cmp.addEventListener('lostpointercapture', stop);
    // Clicking anywhere jumps the handle there (range input already does this on most browsers).
    if (!reduceMotion && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) { cmp.classList.add('is-hinting'); io.disconnect(); }
        });
      }, { threshold: 0.6 });
      io.observe(cmp);
    }
  });

  /* Cart drawer */
  const drawer = () => $('[data-cart-drawer]');
  const openDrawer = () => {
    const d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const close = $('[data-cart-close]', $('.drawer__panel', d));
    close && close.focus();
  };
  const closeDrawer = () => {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  const renderDrawer = (html, open) => {
    const old = drawer();
    if (!old || !html) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const fresh = $('[data-cart-drawer]', tmp);
    if (!fresh) return;
    if (old.classList.contains('is-open') || open) fresh.classList.add('is-open');
    old.replaceWith(fresh);
    const count = fresh.dataset.count;
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.classList.toggle('is-empty', count === '0'); });
    if (open) openDrawer();
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer() && window.FILTRD) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const qtyBtn = e.target.closest('[data-qty], [data-qty-set]');
    if (qtyBtn && qtyBtn.closest('[data-cart-drawer]')) {
      const line = parseInt(qtyBtn.closest('[data-line]').dataset.line, 10);
      const quantity = parseInt(qtyBtn.dataset.qty !== undefined ? qtyBtn.dataset.qty : qtyBtn.dataset.qtySet, 10);
      drawer().classList.add('is-loading');
      fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'] })
      })
        .then((r) => r.json())
        .then((data) => renderDrawer(data.sections && data.sections['cart-drawer'], true))
        .catch(() => { window.location.href = routes.cart || '/cart'; });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeOffer();
  });

  /* Add to cart (AJAX) */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.js-add-form');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form) || document.querySelector(`[form="${form.id}"]`);
    const errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Could not add to cart');
        renderDrawer(data.sections && data.sections['cart-drawer'], true);
      })
      .catch((err) => {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else window.alert(err.message);
      })
      .finally(() => { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* Variant cards update the button price */
  $$('[data-product]').forEach((root) => {
    $$('.offers input[type="radio"]', root).forEach((input) => {
      input.addEventListener('change', () => {
        $$('[data-atc-price]').forEach((el) => { el.textContent = input.dataset.price; });
        $$('[data-atc-variant]').forEach((el) => { el.textContent = input.dataset.title || ''; });
      });
    });
  });

  /* Sticky add-to-cart bar */
  const sticky = $('[data-sticky-atc]');
  const atc = $('[data-atc]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
    }).observe(atc);
  }

  /* First-order popup */
  const KEY = 'filtrd_offer_dismissed';
  function closeOffer() {
    const pop = $('[data-offer-popup]');
    if (!pop || !pop.classList.contains('is-open')) return;
    pop.classList.remove('is-open');
    pop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    try { localStorage.setItem(KEY, String(Date.now())); } catch (err) { /* storage blocked */ }
  }
  const pop = $('[data-offer-popup]');
  if (pop) {
    const openOffer = () => {
      if (document.querySelector('.drawer.is-open')) return;
      pop.classList.add('is-open');
      pop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const field = $('#OfferEmail', pop);
      field && field.focus({ preventScroll: true });
    };
    $$('[data-offer-close]', pop).forEach((b) => b.addEventListener('click', closeOffer));
    const justSignedUp = $('[data-offer-success]', pop) && /customer_posted=true/.test(window.location.search);
    let dismissedAt = 0;
    try { dismissedAt = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (err) { /* storage blocked */ }
    const days = parseInt(pop.dataset.days || '7', 10);
    const recentlyDismissed = Date.now() - dismissedAt < days * 864e5;
    const onCart = /\/cart/.test(window.location.pathname);
    if (justSignedUp) openOffer();
    else if (!recentlyDismissed && !onCart) setTimeout(openOffer, (parseInt(pop.dataset.delay || '6', 10)) * 1000);
  }
})();
